import React from 'react';
import Title from '../../../atoms/Title';
import Logo from '../../../assets/icons/Logo';
import { IHeaderProps } from '../Header';
import HeaderLogoContainer from './HeaderLogoContainer';
import ReactHtmlParser from 'react-html-parser';

interface IHeaderLogoProps {
	centeredLogo: IHeaderProps['centeredLogo'];
	customMessage: IHeaderProps['customMessage'];
	navBarLinks: IHeaderProps['navBarLinks'];
	textLogo: IHeaderProps['textLogo'];
	theme: IHeaderProps['theme'];
	tag: IHeaderProps['tag'];
	tagStyledAs: IHeaderProps['tagStyledAs'];
	logoURL: IHeaderProps['logoURL'];
	logo: IHeaderProps['logo'];
	logoAlt: IHeaderProps['logoAlt'];
	shouldRender: boolean;
}

export default function HeaderLogo(props: Readonly<IHeaderLogoProps>) {
	if (!props.shouldRender) return null;

	if (props.textLogo) {
		return (
			<HeaderLogoContainer
				centeredLogo={props.centeredLogo}
				navBarLinks={props.navBarLinks}
				customMessage={props.customMessage}
			>
				<a
					className={`Header__text${
						props.theme !== 'light' ? '' : '--light'
					}`}
					href={props.textLogo.link}
				>
					<Title tag={props.tag} styledAs={props.tagStyledAs}>
						{ReactHtmlParser(props.textLogo.title)}
					</Title>
				</a>
			</HeaderLogoContainer>
		);
	}

	let logoVariant: 'transparent' | 'light' | 'no-bank' | 'black' | undefined;
	switch (props.theme) {
		case 'dark':
		case 'transparent':
			logoVariant = 'transparent';
			break;
		case 'black-white':
			logoVariant = 'black';
			break;
		case 'no-bank':
			logoVariant = 'no-bank';
			break;
		default:
			logoVariant = undefined;
	}

	return (
		<HeaderLogoContainer
			centeredLogo={props.centeredLogo}
			navBarLinks={props.navBarLinks}
			customMessage={props.customMessage}
		>
			<a className='Header__anchor' href={props.logoURL}>
				{!props.logo ? (
					<Logo
						logoAlt={props.logoAlt}
						aria-label='Credit One Bank Home page'
						className='Header__img'
						variant={logoVariant}
					/>
				) : (
					<img
						className='Header__customImg'
						src={props.logo}
						alt={props.logoAlt}
					/>
				)}
			</a>
		</HeaderLogoContainer>
	);
}
